<template>
  <router-view v-if="usesAuthOnlyShell" />
  <ProductAppShell v-else />
</template>

<script setup>
import '@/styles/main.css';
import '@dashhudson/dashing-ui/component-styles.css';
import { useHead } from '@unhead/vue';
import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

const ProductAppShell = defineAsyncComponent(() => import('@/App.vue'));
const route = useRoute();
const viewportScale = window?.visualViewport?.scale ?? 1;

const usesAuthOnlyShell = computed(() => route.matched.some((record) => record.meta.authOnlyShell));

const metaContent = computed(() =>
  route?.meta?.setResponsiveViewportMetaTag
    ? 'width=device-width, initial-scale=1'
    : `width=device-width, initial-scale=${viewportScale}`,
);

useHead({
  meta: () => [
    {
      name: 'viewport',
      content: metaContent.value,
    },
  ],
});
</script>
